module.exports = __webpack_public_path__ + "@/assets/img/chart-bar.4df3ab61.svg";